//if ofjectFit = contain we should center the image
export default (displayType) => {
  const imageStyles = { objectFit: displayType };
  if (displayType === 'contain') {
    imageStyles.margin = 'auto';
    imageStyles.maxWidth = '100%';
  }
  return imageStyles;
}





// WEBPACK FOOTER //
// ./app/utils/ImageStyleUtils.js